import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  createFilterOptions,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import AppTextEditor from "components/AppTextEditor";
import AppTextInput from "components/AppTextInput";
import Autocomplete from "components/Autocomplete";
import Button from "components/Button";
import CircularProgress from "components/CircularProgress";
import { API_GET_SEARCH } from "constants/constants";
import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendNewMailRequestAction } from "redux/actions/adminActions";
import {
  getAgentsListRequestAction,
  setAgent,
} from "redux/actions/agentActions";
import { getUserWallet } from "redux/actions/usersActions";
import { SEND_NEW_MAIL_STARTED } from "redux/ActionTypes";

const NewMail = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [agentIds, setAgentIds] = useState([]);
  const [userIds, setUserIds] = useState([]);
  const [editorValue, setEditorValue] = useState(null);
  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState([]);
  const [userWallets, setUserWallets] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const dispatch = useDispatch();
  const { agentsList, rType } = useSelector((state) => ({
    agentsList: state.agent.agentsList,
    rType: state.admins.rType,
  }));
  const authToken = useSelector((state) => state.auth.token);
  useEffect(() => {
    dispatch(getAgentsListRequestAction());
  }, []);

  useEffect(() => {
    if (inputValue.length > 3) request();
  }, [inputValue]);

  const request = () => {
    if (!loading) setLoading(true);
    axios
      .get(`${API_GET_SEARCH}?keyword=${encodeURIComponent(inputValue)}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((res) => {
        setLoading(false);
        setOptions(res.data.data);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  const handleChange = debounce((newValue) => {
    setInputValue(newValue);
  }, 400);

  const filterOptions = createFilterOptions({
    stringify: (option) =>
      `${option.firstName} ${option.lastName}` +
      option.email +
      option.mobile?.toString() +
      option.iban?.toString() +
      option.website_domain +
      option?.channel_name,
  });

  const handleSubmit = () => {
    // let errorObj = {};

    // if (subject.length === 0) errorObj.subject = false;
    // if (agentIds.length === 0) errorObj.agentIds = false;
    // if (userIds.length === 0) errorObj.userIds = false;
    // if (message.length === 0) errorObj.message = false;

    // setErrors(errorObj);

    // if (Object.keys(errorObj).length > 0) return;

    let agents = agentIds.map((item) => item.id);
    let users = value.map((item) => item.id);

    dispatch(
      sendNewMailRequestAction({
        agentIds: agents,
        message: JSON.stringify(editorValue),
        subject,
        userIds: users,
        onSuccess: () => {
          setOpen(false);
          setAgentIds([]);
          setValue([]);
          setMessage("");
          setEditorValue(null);
          setSubject("");
        },
      })
    );
  };

  const renderDialog = (
    <Dialog open={open}>
      <DialogTitle>{subject}</DialogTitle>
      <Divider />
      <DialogContent>
        <Typography sx={{ fontWeight: 600 }}>Agents:</Typography>
        {agentIds.map((agent) => (
          <Typography>{agent.name}</Typography>
        ))}
      </DialogContent>
      <Divider />
      <DialogContent>
        <Typography sx={{ fontWeight: 600 }}>Users:</Typography>
        {value.map((agent) => (
          <Typography>{agent.email}</Typography>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          text={"Cancel"}
          variant="text"
          fullWidth={false}
          onClick={() => setOpen(false)}
        />
        <Button
          text={"Submit"}
          onClick={handleSubmit}
          fullWidth={false}
          loading={rType === SEND_NEW_MAIL_STARTED}
        />
      </DialogActions>
    </Dialog>
  );

  return (
    <Card>
      <CardHeader title={"New Mail"} />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <AppTextInput
              label={"Subject"}
              fullWidth
              onChange={(e) => setSubject(e.target.value)}
              error={errors.subject}
            />
          </Grid>
          <Grid item xs={3}>
            <Autocomplete
              multiple
              label={"Agents"}
              options={agentsList}
              getOptionLabel={(option) => option.name}
              value={agentIds}
              onChange={(e, v) => {
                setAgentIds(v);
              }}
              // renderValue={(values, getItemProps) =>
              //   values.map((option, index) => {
              //     const { key, ...itemProps } = getItemProps({ index });
              //     return (
              //       <Chip
              //         key={key}
              //         variant="outlined"
              //         label={option.title}
              //         size="small"
              //         {...itemProps}
              //       />
              //     );
              //   })
              // }
              renderInput={(params) => <TextField {...params} label="Agents" />}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <div
              className={`searchbox right-side-icon bg-transparent d-block`}
              // style={{ width: "320px", maxWidth: "420px" }}
            >
              <Autocomplete
                id="combo-box-demo"
                fullWidth
                options={options}
                getOptionLabel={(option) => (option.email ? option.email : "")}
                loading={loading}
                filterOptions={filterOptions}
                renderOption={(e, option) => {
                  return (
                    <div
                      key={option.id}
                      onClick={(v) => {
                        // e.onClick(v);
                        // navigate(`/app/profile/${String(option.id)}/Summary`);
                        setValue(option);
                        dispatch(
                          getUserWallet({
                            userId: option.id,
                            setData: setUserWallets,
                          })
                        );
                      }}
                      {...e}
                      className={`${e.className} option-container`}
                    >
                      <div>
                        <span>Name: </span>
                        {String(option.firstName) +
                          " " +
                          String(option.lastName)}
                      </div>
                      {/* <div>
                              <span>Mobile:</span> {String(option.mobile)}
                            </div> */}
                      <div>
                        <span>Email:</span> {String(option.email)}
                      </div>
                    </div>
                  );
                }}
                onInputChange={(_, newValue) => {
                  handleChange(newValue);
                }}
                onChange={(_, newValue) => {
                  setValue(newValue);
                  if (Array.isArray(newValue)) {
                    const lastSelected = newValue[newValue.length - 1];
                    if (lastSelected) {
                      dispatch(
                        getUserWallet({
                          userId: lastSelected.id,
                          setData: setUserWallets,
                        })
                      );
                    }
                  }
                  setLoading(false);
                }}
                value={value}
                disablePortal
                clearOnEscape
                autoHighlight
                blurOnSelect
                selectOnFocus
                handleHomeEndKeys
                onBlur={() => {
                  setInputValue("");
                  setLoading(false);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Users"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <div
                          style={{
                            backgroundColor: "white",
                            height: 36,
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          {loading && (
                            <CircularProgress color="primary" size={30} />
                          )}

                          {params.InputProps.endAdornment}
                        </div>
                      ),
                    }}
                  />
                )}
                multiple
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <AppTextEditor
              value={editorValue}
              onChange={(value) => {
                setEditorValue(value);
                setMessage(value.toString("html"));
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Button
          text={"Submit"}
          fullWidth={false}
          onClick={() => setOpen(true)}
        />
      </CardActions>
      {renderDialog}
    </Card>
  );
};

export default NewMail;
